module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/employee/Payslip.ejs -->\n<a class="previous-link js-back-link">\n    <i class="fa fa-angle-left"></i> \n    Back to Previous Payslip\n</a> \n    \n<br/>\n\n<div class="js-payslip-wrapper"></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/employee/Payslip.ejs
// module id = 809
// module chunks = 1